export default "__VITE_ASSET__7601018b__"